import React from "react";
import "./PageLoader.css";
import logo from "@/assets/vaana-logo.png";

export default function PageLoader() {
  return (
    <div className="page-loader">
      <div className="loader-content">
        <img src={logo} alt="Vaana Logo" className="loader-logo" />
        <div className="loader-spinner"></div>
      </div>
    </div>
  );
}
